import { render } from "./RecurringOrderItems.vue?vue&type=template&id=4ee1936d&scoped=true"
import script from "./RecurringOrderItems.vue?vue&type=script&lang=js"
export * from "./RecurringOrderItems.vue?vue&type=script&lang=js"

import "./RecurringOrderItems.vue?vue&type=style&index=0&id=4ee1936d&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee1936d"]])

export default __exports__